import React, { Component } from "react";
import * as d3 from "d3";
import PropTypes from "prop-types";
import Grid from "./grid.jpeg";

class CustomBarChartWithCircle extends Component {
  state = {
    circle_clr: "#dfe3e9",
    text_clr: "#676767",
    colors: ["#4c6ead", "#81efde"],
  };
  componentDidMount() {
    const {
      id,
      width,
      height,
      bar_float,
      label1,
      label2,
      bm_return,
      fund_return,
      stress_test_id,
      stress_test_name,
      bg_color,
      min,
      max,
    } = this.props;
    const { circle_clr, colors, text_clr } = this.state;

    this.drawChart({
      id,
      width,
      height,
      bar_float,
      label1,
      label2,
      bm_return,
      fund_return,
      stress_test_id,
      stress_test_name,
      bg_color,
      circle_clr,
      colors,
      text_clr,
      min,
      max,
    });
  }

  componentWillReceiveProps(nextProps) {
    const {
      id,
      width,
      height,
      bar_float,
      label1,
      label2,
      bm_return,
      fund_return,
      stress_test_id,
      stress_test_name,
      bg_color,
      min,
      max,
    } = nextProps;
    const { circle_clr, colors, text_clr } = this.state;
    this.drawChart({
      id,
      width,
      height,
      bar_float,
      label1,
      label2,
      bm_return,
      fund_return,
      stress_test_id,
      stress_test_name,
      bg_color,
      circle_clr,
      colors,
      text_clr,
      min,
      max,
    });
  }

  drawChart = ({
    id,
    width,
    height,
    bar_float,
    label1,
    label2,
    bm_return,
    fund_return,
    stress_test_id,
    stress_test_name,
    bg_color,
    circle_clr,
    colors,
    text_clr,
    min,
    max,
  }) => {
    d3.select(`#${id}`).selectAll("svg").remove();
    if (width <= 0) return;

    let display = {
      m: { t: 75, b: 75, r: 30, l: 40 },
    };
    let data = [bm_return, fund_return];
    let m = display.m,
      w = width - m.l - m.r,
      h = height - m.t - m.b;

    let barWidth = w * 0.19 > 100 ? 100 : w * 0.19;
    let min_val = d3.min(data);
    let max_val = d3.max(data);
    let _min = min > 0 ? 0 : min;
    let _max = max < 0 ? 0 : max;

    let xScale = d3.scale.ordinal().rangeRoundBands([0, w], 1);
    let yScale = d3.scale.linear().range([h, 0]);

    //-------gray bar-----
    let yScale2 = d3.scale.linear().range([h, 0]).domain([min_val, max_val]);
    // let yAxis2 = d3.svg
    //   .axis()
    //   .scale(yScale2)
    //   .orient("left")
    //   .ticks(6)
    //   .innerTickSize(-w)
    //   .outerTickSize(0)
    //   .tickFormat("");

    //--------------------
    xScale.domain([0, width]);
    yScale.domain([_min, _max]);

    let xAxis = d3.svg
      .axis()
      .scale(xScale)
      .innerTickSize(0)
      .orient("bottom")
      .tickFormat("");

    let yAxis = d3.svg
      .axis()
      .scale(yScale)
      .orient("left")
      .ticks(6)
      .innerTickSize(-w)
      .outerTickSize(0)
      .tickFormat("");

    let svg = d3
      .select(`#${id}`)
      .append("svg")
      .attr("height", h + m.t + m.b)
      .attr("width", w + m.l + m.r)
      .attr("class", "custom_bar_chart__svg");

    if (svg) {
      const chart = svg
        .append("g")
        .attr("transform", () => `translate(${m.l},${m.t - 15})`);

      chart
        .append("g")
        .attr("class", "x axis")
        .attr(
          "transform",
          (d) => `translate(${0},${yScale(0) > 0 ? yScale(0) : 0})`
        )
        .call(xAxis)
        .style("stroke-width", ".4px");

      // --- y axis ----
      // chart.append("g").attr("class", "y axis").call(yAxis);
      // .call((g) => g.select(".domain").remove());

      //-------gray bar-----
      // chart.append("g").attr("class", "y axis").call(yAxis2);
      //--------------------
      let barTransformVal =
        bar_float === "right" && width >= 600
          ? w * 0.7
          : bar_float === "right" && width < 600
          ? w * 0.8
          : bar_float === "left" && width >= 600
          ? w * 0.1
          : bar_float === "right" && width < 600
          ? w * 0.05
          : m.l;

      //-------gray bar-----
      let gray_bar = svg
        .append("g")
        .attr("transform", () => `translate(${barTransformVal},${m.t - 15})`);

      gray_bar
        .selectAll("rect")
        .data(data)
        .enter()
        .append("rect")
        .style("fill", "#dddddd7a")
        .attr("x", (d, i) => {
          return i * barWidth + i * 10;
          // return i * barWidth;
        })
        .attr("y", (d) => {
          if (d >= 0) {
            return yScale(d);
          } else {
            return yScale(0);
          }
        })
        .attr("width", barWidth)
        .attr("height", (d) => Math.abs(yScale2(d) - yScale2(0)))
        .attr("data-rect", (d) => d)
        .append("title")
        .text((d) => d.toFixed(2) + "%");

      //--------------------

      let holder = svg
        .append("g")
        .attr("transform", () => `translate(${barTransformVal},${m.t - 15})`);

      holder
        .selectAll("rect")
        .data(data)
        .enter()
        .append("rect")
        .style("fill", (d, i) => colors[i])
        .attr("x", (d, i) => {
          return i * barWidth + i * 10;
          // return i * barWidth;
        })
        .attr("y", (d) => {
          if (d >= 0) {
            return yScale(d);
          } else {
            return yScale(0);
          }
        })
        .attr("width", barWidth)
        .attr("height", (d) => Math.abs(yScale(d) - yScale(0)))
        .attr("data-rect", (d) => d)
        .append("title")
        .text((d) => d.toFixed(2) + "%");

      // common
      let y_val = 0;
      let val = yScale(0);
      if (val < 0) {
        y_val = 0;
      } else {
        y_val = val;
      }
      // verticle line
      let verticle_line = svg
        .append("g")
        .attr("transform", () => `translate(${w / 2 + 60},${0})`);

      verticle_line
        .append("line")
        .attr("x1", 0)
        .attr("y1", 0)
        .attr("x2", 0)
        .attr("y2", height)
        .style("stroke", text_clr)
        .style("stroke-dasharray", "2.5,2.5");
      //-----------

      //center circle
      let circle = svg
        .append("g")
        .attr("transform", () => `translate(${w / 2},${m.t - 15})`);
      circle
        .append("circle")
        .attr("cx", 60)
        .attr("cy", y_val)
        .attr("r", width <= 600 ? 25 : 50)
        .attr("fill", circle_clr)
        .attr("stroke", text_clr)
        .attr("stroke-width", "1.5")
        .attr("shape-rendering", "geometricPrecision");
      //circle text
      circle
        .append("text")
        .attr("dx", "58")
        .attr("y", y_val)
        .text(stress_test_id)
        .attr("fill", text_clr)
        .attr("dy", ".3em")
        .attr("font-size", "22px")
        .attr("text-anchor", "middle")
        .style("cursore", "default");

      // heading
      let headingTransformValue = bar_float === "left" ? w + 30 : m.l;
      let headingTextAnchor = bar_float === "left" ? "end" : "start";
      let heading = svg
        .append("g")
        .attr("transform", () => `translate(${0},${m.t - 20})`);

      heading
        .append("text")
        .text(stress_test_name.toUpperCase())
        .attr("y", y_val)
        .attr("x", headingTransformValue)
        .attr("text-anchor", headingTextAnchor)
        .style(
          "font-size",
          width <= 600 ? "8px" : width <= 670 ? "18px" : "24px"
        )
        .style("fill", text_clr)
        .style("font-weight", "bold");

      // bar text labels
      let bar_labels = svg
        .append("g")
        .attr("transform", () => `translate(${barTransformVal},${m.t - 20})`);

      bar_labels
        .append("text")
        .text(label1.toUpperCase())
        .attr("y", bm_return <= 0 ? y_val : y_val + 20)
        .attr("x", (d, i) => {
          return barWidth * 0.07;
        })
        .style("fill", text_clr)
        .style("font-size", width <= 600 ? "7px" : "14px")
        .style("font-weight", "bold");

      bar_labels
        .append("text")
        .text(label2.toUpperCase())
        .attr("y", fund_return <= 0 ? y_val : y_val + 20)
        .attr("x", (d, i) => {
          return barWidth * 0.1 + barWidth + 10;
        })
        .style("font-size", width <= 600 ? "7px" : "14px")
        .style("font-weight", "bold")
        .style("fill", text_clr);

      // bar value labels
      let bar_values = svg
        .append("g")
        .attr("transform", () => `translate(${barTransformVal},${m.t - 20})`);

      let val_bm =
        bm_return > 0 ? "+" + bm_return.toFixed(2) : bm_return.toFixed(2);

      let val_fr =
        fund_return > 0 ? "+" + fund_return.toFixed(2) : fund_return.toFixed(2);
      bar_values
        .append("text")
        .text(val_bm + "%")
        .attr("x", () => {
          return barWidth * 0.28;
        })
        .attr("y", () => {
          if (bm_return <= 0) {
            return yScale(bm_return) + 25;
          } else {
            return 0;
          }
        })
        .style("font-size", width <= 600 ? "10px" : "15px")
        .style("font-weight", "bold")
        .style("fill", text_clr);

      bar_values
        .append("text")
        .text(val_fr + "%")
        .attr("x", () => {
          return barWidth * 0.28 + barWidth + 10;
        })
        .attr("y", () => {
          if (fund_return <= 0) {
            return yScale(fund_return) + 25;
          } else {
            return 0;
          }
        })
        .style("font-size", width <= 600 ? "10px" : "15px")
        .style("font-weight", "bold")
        .style("fill", text_clr);
    }
  };

  render() {
    const { id, bg_color, width } = this.props;
    return (
      <div
        className="custom_bar_chart"
        id={id}
        style={{
          backgroundColor: bg_color ? "#eaf0f8" : "",
          backgroundImage: bg_color == false ? `url(${Grid})` : "",
          width,
        }}
      ></div>
    );
  }
}
CustomBarChartWithCircle.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  bar_float: PropTypes.string.isRequired,
  label1: PropTypes.string,
  label2: PropTypes.string,
  bm_return: PropTypes.number.isRequired,
  fund_return: PropTypes.number.isRequired,
  stress_test_id: PropTypes.number.isRequired,
  stress_test_name: PropTypes.string.isRequired,
  bg_color: PropTypes.bool,
};

CustomBarChartWithCircle.defaultProps = {
  label1: "Benchmark",
  label2: "Portfolio",
  bg_color: false,
};

export default CustomBarChartWithCircle;



// WEBPACK FOOTER //
// ./src/components/d3Components/customBarchartWithCircle/CustomBarChartWithCircle.jsx